<template>
  <a-modal title="快速设定" okText="确认" cancelText="取消" width="700px" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
    <a-form-model ref="ruleForm" :model="formState" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="判定值" prop="judgeValue">
            <a-input-number v-model="formState.judgeValue" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="单位" prop="judgeUnit">
            <a-select  v-model="formState.judgeUnit">
              <a-select-option value="mg/kg">mg/kg</a-select-option>
              <a-select-option value="g/kg">g/kg</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="判定值来源" prop="valueFrom">
            <a-select v-model="formState.valueFrom">
              <a-select-option value="参考">参考</a-select-option>
              <a-select-option value="自定义">自定义</a-select-option>
              <a-select-option value="引用">引用</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="使用规定" prop="useFor">
            <div style="display: inline-block; width: 150px">
              <a-ext-local-dic-select dic-key="JudgeUseFor" v-model="formState.useFor"></a-ext-local-dic-select>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { UpdateBatchStdJudgeItem as saveApi} from '../../../api/api';
import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect';
export default {
  name: 'AddQuickSetModal',
    components: {
        AExtLocalDicSelect
    },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    param: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 提交状态
      confirmLoading: false,
      // 表格数据
      formState: {
        judgeValue: '',
        judgeUnit: '',
        valueFrom: '',
        useFor: '',
      },
    };
  },
  created() {},
  methods: {
    handleOk(e) {
      this.confirmLoading = true;
      let form = {
          ...this.formState,
          ...this.param
      }
      saveApi(form)
        .then((result) => {
          this.confirmLoading = false;
          this.$emit('addModalClose', true);
          this.$emit('update:visible', false);
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    handleCancel(e) {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .ant-modal-body {
  /*height: 60vh;*/
  /*overflow-y: scroll;*/
}
</style>
